<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增规则' : '编辑规则'"
      width="1200"
      ref="formModel"
    >
      <template slot="markerList">
        <div class="btnwrap">
          <Dropdown>
            <Button size="small">新增站点</Button>
            <template #list>
              <DropdownMenu>
                <DropdownItem
                  ><span
                    @click="
                      openPoint = true;
                      now = 'markerList';
                    "
                    >从标注点引入</span
                  >
                </DropdownItem>
                <DropdownItem>
                  <span @click="addPoints('markerList')">自行搜索地址</span>
                </DropdownItem>
              </DropdownMenu>
            </template>
          </Dropdown>

          <Button
            size="small"
            v-show="item.markerList.length > 0"
            @click="item.markerList = []"
            >清空站点</Button
          >
        </div>

        <div class="stationWrap">
          <div class="stationWrapline"></div>

          <div class="stations">
            <station
              v-for="(x, index1) in item.markerList"
              :key="index1"
              :station="x"
              @del="item.markerList.splice(index1, 1)"
              @update="update(index1, 'markerList')"
              >{{ fsdc(index1, item.markerList.length - 1) }}</station
            >
          </div>
        </div>
      </template>
      <bind slot="deviceIdList" ref="bind" v-model="deviceList"></bind>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>

    <selectMapTool ref="addPoints" @add="reAdd"></selectMapTool>
    <Modal v-model="openPoint" footer-hide width="1200" fullscreen>
      <point
        v-if="openPoint"
        :scan="true"
        :checkMore="true"
        @objs="reobj"
      ></point>
    </Modal>
    <form-model width="1200" ref="myForm" title="修改站点信息">
      <div style="width: 100%; height: 300px" slot="map">
        <lypoint ref="mypoint"></lypoint>
      </div>
      <Input slot="address" v-model="stationItem.address">
        <template #suffix>
          <Button @click="autoGetAddress">自动获取</Button>
        </template>
      </Input>
      <Button slot="btn" type="primary" @click="updateStaion">确认修改</Button>
    </form-model>
  </div>
</template>
<script>
import station from "./station.vue";
import selectMapTool from "./selectMapTool.vue";
import point from "./rulePoint.vue";
import lypoint from "../map/point.vue";
import bind from "./bind.vue";

export default {
  components: { station, selectMapTool, point, lypoint, bind },
  data() {
    return {
      isAdd: false,
      openDrawer: false,
      openAuto: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 140,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        name: "",
        deviceIdList: [],
        groupId: "",
        groupName: "",
        markerList: [],
        remark: "",
      },
      forms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
          span: 8,
          sort: 2,
        },
        {
          title: "所属单位",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
          span: 8,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          span: 8,
          sort: 2,
        },
        {
          title: "位置站点",
          key: "markerList",
          key2: "markerList2",
          slotForm: "markerList",
          span: 24,
        },
        {
          title: "绑定车牌",
          key: "deviceIdList",
          key2: "deviceIdList2",
          noTable: true,
          slotForm: "deviceIdList",
          span: 24,
        },
      ],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        },
      ],
      total: 0,
      openPoint: false,
      stationItem: {
        name: "aaa",
        x: 113,
        y: 22,
        radius: 50,
        address: "",
        type: "",
        id: "",
      },
      stationForms: [
        {
          title: "地址简称",
          slotForm: "map",
          span: 24,
          hideLabel: true,
        },
        {
          title: "地址简称",
          key: "name",
          type: "Input",
          required: true,
          span: 6,
          sort: 2,
        },
        {
          title: "半径/米",
          key: "radius",
          type: "Select",
          selectItems: [50, 100, 200, 500, 1000],
          required: true,
          span: 6,
          sort: 2,
        },
        {
          title: "标注类型",
          key: "type",
          type: "Select",
          selectItems: this.lydic.getA("markersType"),
          required: true,
          span: 6,
          sort: 2,
        },
        {
          title: "详细地址",
          key: "address",
          slotForm: "address",
          required: false,
          span: 11,
          sort: 2,
        },
      ],
      now: "markerList",
      deviceList: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/markers/list",
        data: {},
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }

      var t = this.$refs.bind.getResult();

      this.item.deviceIdList = [];

      for (let i = 0; i < t.length; i++) {
        this.item.deviceIdList.push(t[i].id);
      }
      this.item.markerList=this.setId(this.item.markerList);
 
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.rule + "/markers/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.rule + "/markers/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.rule + "/markers/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
      this.getItem(row);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    selectCartype(x) {
      this.selectIcon = x.value;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    fsdc(index, t) {
      if (index == 0) {
        return "";
      } else if (index == t) {
        return "";
      } else {
        return "";
      }
    },
    addPoints(now) {
      this.$refs.addPoints.openMap();
      this.now = now;
    },
    reAdd(v) {
      v.radius = 100;
      v.cs = 2;
      this.item[this.now].splice(1, 0, v);
    },
    reobj(v) {
      var arr = this.item[this.now];
      for (let i = 0; i < v.length; i++) {
        var obj = {
          name: v[i].name,
          address: v[i].address == null ? "暂无详细地址" : v[i].address,
          radius: v[i].radius,
          type: v[i].type,
          x: v[i].x,
          y: v[i].y,
          cs: 2,
        };
        arr.push(obj);
      }

      arr = arr.filter(
        (item, index) => arr.findIndex((i) => i.name === item.name) === index
      );
      //this.paixu();
      this.openPoint = false;
    },
    setId(v) {
      var d = Date.now();
      for (let i = 0; i < v.length; i++) {
        if (!v[i].id) {
          v[i].id = d + 1000 * i;
        }
      }
      return v;
    },
    fanzhuan(v) {
      this.item[v].reverse();
    },
    autoStation(a, b) {
      this.item[a] = JSON.parse(JSON.stringify(this.item[b])).reverse();
    },
    //更新站点
    update(index, now) {
      this.stationItem = this.item[now][index];
      this.$refs.myForm.reach(this.stationForms, this.stationItem);

      setTimeout(() => {
        this.$refs.mypoint.drawMap(this.stationItem);
      }, 200);
    },
    //更新站点
    updateStaion() {
      var a = this.$refs.myForm.getItem();
      if (!a) {
        return;
      }
      var ccc = this.$refs.mypoint.getPoint();
      this.stationItem.x = ccc.x;
      this.stationItem.y = ccc.y;
      this.$refs.myForm.close();
    },
    getItem(row, type) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/markers/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        if (res) {
          if (type == 1) {
            var data = res.data.data.fenceRuleList;
            var arr = [];
            for (const i in data) {
              arr.push(data[i].id);
            }
            this.item.fenceRuleIdList = arr;
            this.openForm = true;
          } else {
            var d = res.data.data.deviceList;
            this.deviceList = [];
            for (let i = 0; i < d.length; i++) {
              var obj = {
                id: d[i].deviceId,
                name: d[i].bindAttr,
                key: d[i].deviceId,
                useType: d[i].useType,
              };
              this.deviceList.push(obj);
            }
          }
        }
      });
    },
    openBlind(row) {
      this.getItem(row);
      this.blindId = row.id;
    },
    blind(data) {
      this.utils.loading(this, "处理中");
      var deviceIdList = [];
      for (const i in data) {
        deviceIdList.push(data[i].id);
      }
      this.axios({
        method: "post",
        url: this.axios.trp + "/timesRule/bind",
        data: { deviceIdList: deviceIdList, id: this.blindId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
      });
    },
    autoGetAddress() {
      var ccc = this.$refs.mypoint.getPoint();
      var pointList = [
        {
          x: ccc.x,
          y: ccc.y,
        },
      ];

      this.utils.jiexi(pointList).then((data) => {
        this.stationItem.address =
          data[0].address == null ? "暂无地址" : data[0].address;
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style>
.stationWrap {
  position: relative;
}
.stationWrap .stations {
  margin: 0 auto;
  position: relative;
  display: flex;
  height: 120px;
  border-bottom: solid 1px #ccc;
}
.btnwrap {
  margin-bottom: 10px;
}
.btnwrap .tishi {
  color: red;
  padding: 6px;
}
.stationWrapline {
  position: absolute;
  width: 100%;
  height: 6px;
  background: #77c0ed;
  top: 6px;
  z-index: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/rule/rulePoints.vue